'use client';

import React from 'react';
import { Tabs, Tab, TabPanel, TabSet } from 'src/components';
import { useAuthorization } from 'src/hooks/authorization';
import { UserTable, RolesAdmin, TeamManagement } from './components';
const CompanyDetails = () => {
  const { userManagementCapabilities } = useAuthorization();
  const { isStaff } = userManagementCapabilities;

  // Roles & Teams are MedScout-internal administration surfaces — advanced tier
  // only. A License Manager gets the Users tab alone.
  const tabOptions = [
    { label: 'Users', component: <UserTable />, show: true },
    {
      label: 'Roles & Permissions',
      component: <RolesAdmin />,
      show: isStaff,
    },
    {
      label: 'Teams',
      component: <TeamManagement />,
      show: isStaff,
    },
  ].filter((tab) => tab.show);

  return (
    <Tabs>
      <div className="flex flex-col gap-4">
        <div className="grid grid-cols-6 gap-2">
          <div className="col-span-2 sm:col-span-1">
            <TabSet id="preferences-tabs" direction="vertical">
              {tabOptions.map((tab, index) => (
                <Tab key={tab.label} tabSetId="preferences-tabs" index={index}>
                  {tab.label}
                </Tab>
              ))}
            </TabSet>
          </div>
          <div className="col-span-4 sm:col-span-5">
            {tabOptions.map((tab, index) => (
              <TabPanel
                key={tab.label}
                tabSetId="preferences-tabs"
                index={index}
              >
                <div className="px-4">{tab.component}</div>
              </TabPanel>
            ))}
          </div>
        </div>
      </div>
    </Tabs>
  );
};

export default CompanyDetails;
